import { render, staticRenderFns } from "./google_review_params.vue?vue&type=template&id=6b64d5d8&scoped=true&"
import script from "./google_review_params.vue?vue&type=script&lang=js&"
export * from "./google_review_params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64d5d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b64d5d8')) {
      api.createRecord('6b64d5d8', component.options)
    } else {
      api.reload('6b64d5d8', component.options)
    }
    module.hot.accept("./google_review_params.vue?vue&type=template&id=6b64d5d8&scoped=true&", function () {
      api.rerender('6b64d5d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/providers/google_review_params.vue"
export default component.exports